import throttle from 'lodash/throttle'
import debounce from 'lodash/debounce'

export default class StickyHeader {
  constructor () {
    this.el = document.getElementById('js-sticky-header')
    this.mediaQuery = window.matchMedia('only screen and (min-width: 1280px)')
    this.handlers = {}
    this.isActive = false
    this.threshold = void 0

    this.init()
    this.handleEvents(true)
    this.onResize()
  }

  init () {
    this.handlers.scroll = throttle(this.onScroll.bind(this), 16, { leading: true, trailing: true })
    this.handlers.resize = debounce(this.onResize.bind(this), 50)
  }

  handleEvents (isInit) {
    if (isInit) this.mediaQuery.addListener(this.onChangeMedia.bind(this))

    if (this.mediaQuery.matches && !this.isActive) {
      window.addEventListener('scroll', this.handlers.scroll)
      window.addEventListener('resize', this.handlers.resize)
      this.isActive = true
    } else if (!this.mediaQuery.matches && this.isActive) {
      window.removeEventListener('scroll', this.handlers.scroll)
      window.removeEventListener('resize', this.handlers.resize)
      this.isActive = false
    }
  }

  onChangeMedia () {
    this.handleEvents(false)
  }

  onScroll () {
    const scrollTop = this.getScrollTop()

    if (scrollTop > this.threshold) {
      this.el.classList.add('is-active')
    } else {
      this.el.classList.remove('is-active')
    }
  }

  onResize () {
    this.threshold = this.el.clientHeight
    this.onScroll()
  }

  getScrollTop () {
    return (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop
  }
}



// WEBPACK FOOTER //
// ./src/komachi-official/assets/scripts/modules/StickyHeader.js